import { styled } from 'styled-components';

export const SelectContainer = styled.div`
  * {
    word-break: break-all;
  }
`;
